import { UnitType } from '@exodus/currency'

const name = 'zilliqa'
const displayName = 'Zilliqa'
const ticker = 'ZIL'
const displayTicker = ticker
const displayNetworkTicker = displayTicker
const displayNetworkName = displayName
const baseAssetName = name
const primaryColor = '#29CCC4'
const gradientColors = ['#29CCC4', '#167D82']
const gradientCoords = { x1: '0%', y1: '21.958%', x2: '100%', y2: '79.18%' }
const chainBadgeColors = gradientColors

const units = {
  qa: 0,
  ZIL: 12,
}
const currency = UnitType.create(units)

const assetType = 'OTHER'
const blockExplorer = {
  addressUrl: (address) => `https://viewblock.io/zilliqa/address/${encodeURIComponent(address)}`,
  txUrl: (txId) => `https://viewblock.io/zilliqa/tx/0x${encodeURIComponent(txId)}`,
}
const info = {
  description:
    'Zilliqa is a platform that seeks to make blockchains faster and scalable by streamlining the consensus process with a system called sharding.',
  twitter: 'https://twitter.com/zilliqa',
  website: 'https://www.zilliqa.com/',
  telegram: 'https://t.me/zilliqachat',
}

export const tokens = undefined
export const asset = {
  assetType,
  baseAssetName,
  blockExplorer,
  chainBadgeColors,
  currency,
  displayName,
  displayNetworkName,
  displayNetworkTicker,
  displayTicker,
  gradientColors,
  gradientCoords,
  info,
  name,
  primaryColor,
  properName: displayName, // deprecated,
  properTicker: displayTicker, // deprecated,
  ticker,
  toString: () => name,
  units,
}

export default [asset]
